import React, { useContext } from 'react';
import { StyledDays, StyledDay, StyledWeekDays } from './index.styles';
import { CalendarContext } from '../index.context';
import { Text } from '../../../Atoms';
import { Actions, WeekDays } from '../index.constants';

const weekDaysSubstr = WeekDays.map(weekDay => weekDay.substring(0, 3));

export const Days = ({ ...otherProps }) => {
    const {
        dispatch,
        state: { selectedDate, date },
    } = useContext(CalendarContext);

    const year = date.getFullYear();
    const month = date.getMonth();

    const firstWeekDayOfMonth = new Date(year, month, 1).getDay();
    const offset = firstWeekDayOfMonth;
    const days = Array.from({ length: new Date(year, month + 1, 0).getDate() }).map(
        (value, index) => index + 1,
    );

    return (
        <StyledDays {...otherProps}>
            <StyledWeekDays>
                {weekDaysSubstr.map(weekDay => (
                    <Text key={weekDay}>{weekDay}</Text>
                ))}
            </StyledWeekDays>
            {days.map((d, index) => (
                <StyledDay
                    key={`${year}/${month}/${d}`}
                    selected={
                        selectedDate.getFullYear() === year &&
                        selectedDate.getMonth() === month &&
                        d === selectedDate.getDate()
                    }
                    offset={index === 0 ? offset : 0}
                    holiday={
                        (d + firstWeekDayOfMonth - 1) % 7 === 0 ||
                        (d + firstWeekDayOfMonth - 1) % 7 === 6
                    }
                    onClick={() => dispatch({ type: Actions.SELECT_DAY, day: d })}
                >
                    <Text>{d}</Text>
                </StyledDay>
            ))}
        </StyledDays>
    );
};
